<template>
    <div class="checkout">
        <v-container style="padding-top: 70px; min-height: calc(100vh - 350px);" class="pb-8">
            <v-row align="center">
                <v-col cols="4">
                    <v-breadcrumbs :items="items" divider="|" class="px-0"></v-breadcrumbs>
                </v-col>
                <v-col cols="4" class="text-center">
                    <h1 class="titulo" style="letter-spacing:1px;">MI CUENTA</h1>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="auto">
                    <router-link to="/mi-cuenta/pedidos" class="menu-item-mi-cuenta">
                        MIS PEDIDOS
                    </router-link>
                </v-col>
                <v-col cols="auto" class="px-6">
                    <router-link to="/mi-cuenta" class="menu-item-mi-cuenta">
                        MIS DATOS
                    </router-link>
                </v-col>
                <v-col cols="auto">
                    <span class="menu-item-mi-cuenta d-inline-block" style="height: 18px;" @click="logout">
                        CERRAR SESIÓN
                    </span>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="6" md="4" lg="4">
                     <v-form>
                        <v-text-field type="email" v-model="login.email" label="CORREO ELECTRÓNICO" color="#979797" :disabled="bloqueado">
                        </v-text-field>

                        <v-text-field type="text" v-model="login.Nombre" label="Nombre y apellidos" color="#979797">
                        </v-text-field>


                        <v-row align="center" v-if="!this.$session.get('user').user.Profesional">
                            <v-col cols="1">        
                                <v-checkbox
                                    v-model="login.Profesional"
                                    color="#064434"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="11" class="text-left">        
                                <span class="modernist d-block mb-2" style="font-size: 10px;" @click="profesional = !profesional">¿Quieres registrarte con un perfil profesional?</span>
                            </v-col>
                        </v-row>
                        <template v-if="this.$session.get('user').user.Profesional || login.Profesional">

                            <v-text-field type="text" v-model="login.Empresa" label="Empresa" color="#979797">
                            </v-text-field>

                            <v-text-field type="text" v-model="login.Ocupacion" label="Ocupación" color="#979797">
                            </v-text-field>

                            <v-text-field type="text" v-model="login.Especialidad" label="Área de Especialidad" color="#979797">
                            </v-text-field>

                            <v-text-field type="text" v-model="login.Telefono" label="Telefóno Móvil" color="#979797">
                            </v-text-field>

                        </template>


                     </v-form>


                    <v-btn block tile elevation="0" :ripple="false" color="#064434" dark class="mb-12" @click="guardarPerfil()">
                        <span class="modernist-bold" style="font-size:12px;">
                            GUARDAR PERFIL
                        </span>
                    </v-btn>

                </v-col>
            </v-row>

        </v-container>

    </div>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({
        items: [{
                text: "Inicio",
                disabled: false,
                to: "/"
            },
            {
                text: "Mi cuenta",
                disabled: false,
                to: "/mi-cuenta"
            },
            {
                text: "Mis datos",
                disabled: true
            }
        ],
        login: {
            email: '',
            Nombre: '',
            Empresa: '',
            Ocupacion: '',
            Especialidad: '',
            Telefono: '',
            Profesional: false
        },
        bloqueado: true
    }),
    created: function(){
        if(this.$session.exists('user')){
            var aux = this.$session.get('user');

            console.log(aux);

            this.login.email = aux.user.email;
            this.login.Nombre = aux.user.Nombre;
            this.login.Empresa = aux.user.Empresa;
            this.login.Ocupacion = aux.user.Ocupacion;
            this.login.Especialidad = aux.user.Especialidad;
            this.login.Telefono = aux.user.Telefono;
            this.login.Profesional = aux.user.Profesional;
        }
    },
    methods: {
        logout: function(){
            this.$session.clear();
            this.$router.push('/');
        },
        guardarPerfil: function(){
            var aux = this;


            var usuario = this.$session.get('user');
            axios
            .put("https://strapi.actstudio.xyz/users/"+this.$session.get('user').user.id, this.login)
            .then(function(res){
                usuario.user = res.data;
                console.log(res);
                aux.$session.set("user", usuario);
                aux.$router.push('/mi-cuenta');
            });
        }
    },
    mounted: function(){
        gtag('config', 'UA-163902944-1', {
            'page_title' : 'Editar Perfil',
            'page_path': '/mi-cuenta/editar-perfil'
        });
    }
}
</script>